var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpDownCarets(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.7 20.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.69,8.21c-.2,0-.4-.06-.58-.19l-7.77-5.56L1.58,8.02c-.45.32-1.07.22-1.4-.23-.32-.45-.22-1.07.23-1.4L9.35,0l8.93,6.39c.45.32.55.95.23,1.4-.2.27-.5.42-.81.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35,20.41L.42,14.02c-.45-.32-.55-.95-.23-1.4.32-.45.95-.55,1.4-.23l7.77,5.56,7.77-5.56c.45-.32,1.07-.22,1.4.23.32.45.22,1.07-.23,1.4l-8.93,6.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownCarets);
export default __webpack_public_path__ + "static/media/up-down-carets.6d38e7555d04f163dfc0bff91c24167d.svg";
export { ForwardRef as ReactComponent };